import { render, staticRenderFns } from "./revisarEvaluacion.vue?vue&type=template&id=68830810"
import script from "./revisarEvaluacion.vue?vue&type=script&lang=js"
export * from "./revisarEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./revisarEvaluacion.vue?vue&type=style&index=0&id=68830810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports